import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CRISIS_HOTLINE_NUMBERS } from '@lighthouse/shared';

export function CrisisBanner() {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="border-t border-white/10 px-4 py-1.5 sm:px-6 lg:px-8">
      <p className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-1.5 text-center text-xs text-white/70">
        <span>{t('crisis.banner')}</span>
        <a
          href={`tel:${CRISIS_HOTLINE_NUMBERS.NIGERIA}`}
          className="font-medium text-white underline decoration-white/40 underline-offset-2"
        >
          {CRISIS_HOTLINE_NUMBERS.NIGERIA}
        </a>
        <span>{t('crisis.or')}</span>
        <a
          href={`tel:${CRISIS_HOTLINE_NUMBERS.LAGOS}`}
          className="font-medium text-white underline decoration-white/40 underline-offset-2"
        >
          {CRISIS_HOTLINE_NUMBERS.LAGOS}
        </a>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="ml-1 rounded px-1 text-white/60 hover:text-white"
          aria-label="Dismiss crisis notice"
        >
          {t('common.close')}
        </button>
      </p>
    </div>
  );
}
